export function useScrollTo() {
  const scrollTo = (targetId) => {
    const element = document.querySelector(`#${targetId}`);
    element?.scrollIntoView({ behavior: 'smooth' });
  };

  return scrollTo;
}